import { cloneDeep } from 'lodash'

/**
 * 将列表形式的数据转换为树形结构
 * @param {Array} list 需要转化为树形结构的列表数据
 * @param {String} uniqueKey 标识列表数据的唯一键，也是列表数据的关联标识
 * @param {Number} parentKey 当前的根节点id（当parentId为该值时，则当前数据为根节点）
 * @return Tree数据
 */
export function transListToTree(
  list,
  uniqueKey,
  parentKey = 'parentId',
  isShow = false
) {
  // 先将parentId进行分组
  const parentGroup = {}
  const uniqueKeyList = []

  list.forEach(value => {
    uniqueKeyList.push(String(value[uniqueKey]))
    const key = value[parentKey]
    if (key in parentGroup) {
      parentGroup[key].push(value)
    } else {
      parentGroup[key] = [value]
    }
  })

  const departmentTree = []
  // 确定根节点，且保证为array类型
  // 判断逻辑，父id分组中的唯一键不存在于唯一键数组中,
  // 需要注意从Object.keys中返回的键，会将Number改成String
  Object.keys(parentGroup).forEach(parentKey => {
    if (!uniqueKeyList.includes(parentKey)) {
      departmentTree.push(...parentGroup[parentKey])
    }
  })

  // 递归函数，组装Tree数据
  const loopFun = parentNode => {
    parentNode.forEach(parentObject => {
      if (parentObject[uniqueKey] in parentGroup) {
        parentObject.children = cloneDeep(parentGroup[parentObject[uniqueKey]])

        loopFun(parentObject.children)
      }
    })
  }
  loopFun(departmentTree)

  return departmentTree
}

/**
 * 将树结构展开为一个扁平的数组。
 *
 * @param {Array} tree - 要展开的树结构。
 * @return {Array} 展开后的数组。
 */
export function flattenTree(tree) {
  const tempTree = cloneDeep(tree)
  const result = []

  function traverse(node) {
    result.push(node) // 将当前节点添加到数组中
    if (node.children) {
      node.children.forEach(child => traverse(child)) // 递归处理子节点
      node.children = []
    }
  }

  console.log('tempTree', tempTree)
  tempTree.forEach(root => traverse(root)) // 对每个树的根节点调用递归函数

  return result
}

/**
 * 根据关键字过滤树形数据结构。
 * @param {Array} tree - 要过滤的树形数据结构。
 * @param {string} value - 用于过滤树形结构的值。
 * @param {string} titleField - 用于过滤树形结构的title关键字，可以自定为 name、supplierName等。
 * @return {Array} 过滤后的树形数据结构。
 */
export function filterTree(tree, value, titleField = 'title') {
  return cloneDeep(tree)
    .map(node => {
      if (node.children) {
        node.children = filterTree(node.children, value, titleField)
      }
      if (node.children && node.children.length === 0) {
        delete node.children
      }
      return node
    })
    .filter(node => {
      // 判断节点是否匹配搜索关键字
      return (
        node[titleField].toLowerCase().includes(value.toLowerCase()) ||
        (node.children && node.children.length > 0)
      )
    })
}
